import React, { Component } from 'react'
import modile from '../../images/icon/operators.svg'
import qiwi from '../../images/icon/qiwi.svg'
import visa from '../../images/icon/visaMc.svg'
import modileSelect from '../../images/icon/operatorsSelected.svg'
import visaSelect from '../../images/icon/visaMcSelected.svg'
import classes from "../Exchanger/Exchanger.module.css"


export default class Payway extends Component {

    render = () => {
        const { payway, checked } = this.props

        switch (payway) {
            case 'VISA_MC_P2P':
                return (
                    <>
                        <div className={classes.payways}>
                            Visa/MC P2P
                        </div>
                        <div className={classes.payway__item}>
                            <img src={checked === payway ? visaSelect : visa} alt={'visa, mastercard'} />
                        </div>
                    </>
                )
            case 'VISA_MC_WW':
                return (
                    <>
                        <div className={classes.payways}>
                            Visa/MC Worldwide
                        </div>
                        <div className={classes.payway__item}>
                            <img src={checked === payway ? visaSelect : visa} alt={'visa, mastercard'} />
                        </div>
                    </>
                )
            case 'VISA_MC':
                return (
                    <>
                        <div className={classes.payways}>
                            Visa/MC
                        </div>
                        <div className={classes.payway__item}>
                            <img src={checked === payway ? visaSelect : visa} alt={'visa, mastercard'} />
                        </div>
                    </>
                )
            case 'QIWI':
                return (
                    <>
                        <div className={classes.payways}>
                            Qiwi
                        </div>
                        <div className={classes.payway__item}>
                            <img src={qiwi} alt={'qiwi'} />
                        </div>
                    </>
                )
            case 'MOBILE_PHONE':
                return (
                    <>
                        <div className={classes.payways}>
                            Mobile
                        </div>
                        <div className={classes.payway__item}>
                            <img src={checked === payway ? modileSelect : modile} alt={'mobile phone'} />
                        </div>
                    </>
                )
            default:
                return (
                    <>
                        <div className={classes.payways}>

                        </div>
                        <div className={classes.payway__item}>

                        </div>
                    </>
                )
        }
    }
}
